export default __webpack_public_path__ + "606655f55824a822b2b6cb80180feae7.png";